module.exports = __webpack_public_path__ + "6f6f461c1ece6f991f380acc8333d352.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1129
// module chunks = 0